enum FileTypes {
  PDF = 'pdf',
  PNG = 'png'
}

enum TemplateTypes {
  A4Document,
  Announcement,
  Brochure,
  BusinessCard,
  Card,
  EtsyShopCover,
  EtsyShopIcon,
  FacebookAd,
  FacebookAppAd,
  FacebookCover,
  FacebookEventCover,
  FacebookPost,
  Flyer,
  GiftCertificate,
  Infographic,
  InstagramPost,
  InstagramStory,
  Invitation,
  Invoice,
  Label,
  LargeRectangleAd,
  LeaderboardAd,
  Letter,
  LinkedInBanner,
  Logo,
  MediumRectangleAd,
  Menu,
  MindMap,
  Newsletter,
  PhotoCollage,
  PinterestGraphic,
  Postcard,
  Poster,
  Presentation,
  Presentation43,
  ProductLabel,
  RecipeCard,
  Resume,
  SnapchatGeofilter,
  SocialMedia,
  Ticket,
  TwitterHeader,
  TwitterPost,
  WideSkyscraperAd,
  YouTubeChannelArt,
  YouTubeThumbnail,
}

const templateFileTypes = {
  [FileTypes.PDF]: [
    TemplateTypes.A4Document,
    TemplateTypes.Announcement,
    TemplateTypes.Brochure,
    TemplateTypes.Card,
    TemplateTypes.Flyer,
    TemplateTypes.GiftCertificate,
    TemplateTypes.Invitation,
    TemplateTypes.Invoice,
    TemplateTypes.Label,
    TemplateTypes.Letter,
    TemplateTypes.Menu,
    TemplateTypes.MindMap,
    TemplateTypes.Newsletter,
    TemplateTypes.Postcard,
    TemplateTypes.Poster,
    TemplateTypes.Presentation,
    TemplateTypes.Presentation43,
    TemplateTypes.RecipeCard,
    TemplateTypes.Resume,
    TemplateTypes.Ticket,
  ]
};

export const templateTypeDetails: any[] = [];
Object.keys(TemplateTypes).forEach((i) => {
  const numI = parseInt(i, 10);
  if (!TemplateTypes[numI]) {
    return;
  }
  templateTypeDetails.push({
    value: TemplateTypes[numI],
    label: TemplateTypes[numI]?.match(/[A-Z]([0-9]*[a-z]*)+/g)?.join(" "),
    fileType: templateFileTypes[FileTypes.PDF].includes(numI) ? FileTypes.PDF : FileTypes.PNG
  });
});

// adjusted copy from https://www.canva.com/button/documentation/js-api/
export interface CanvaButtonApi {
  createDesign: (opts: {
    type: string;
    width?: number;
    height?: number;
    units?: string;
    publishLabel?: string;
    fileType?: string;
    onDesignOpen?: (opts: { designId: string }) => void;
    onDesignPublish?: (opts: { exportUrl: string; designId: string }) => void;
  }) => void;
  editDesign: (opts: {
    designId: string;
    publishLabel?: string;
    fileType?: string;
    onDesignOpen?: (opts: { designId: string }) => void;
    onDesignPublish?: (opts: { exportUrl: string; designId: string }) => void;
  }) => void;
}
